// @flow
import React from 'react';
// Styles
import './InfoCards.css';

type InfoCard = {
  title: string,
  text: string,
  img: string,
};

type ClassNamesConfig = {
  container?: string,
  card?: string,
  image?: string,
};

type Props = {
  cards: InfoCard[],
  classNames?: ClassNamesConfig,
};

const InfoCards = ({ cards, classNames = {} }: Props) => {
  return (
    <div className={`product-info-cards ${classNames.container || ''}`}>
      {cards.map(({ title, img, text }) => (
        <div
          className={`product-info-card ${classNames.card || ''}`}
          key={title}
        >
          <img src={img} alt={title} className={classNames.image || ''} />
          <div className="product-info-card-content">
            <h6 className="product-info-card-content-title">
              {title}
              <span>{text}</span>
            </h6>
          </div>
        </div>
      ))}
    </div>
  );
};

export default InfoCards;
